import { useGet } from "@albertine/api-client";
import { TenantSchema } from "@albertine/types/openapi/lmt";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { useClaims } from "../../utils/claims.util";
import { NewMemberForm } from "./NewMemberForm";

type Props = {
    onClose: () => void;
    defaultAssignedTo?: string | undefined;
};

export function InviteNewMember({ onClose, defaultAssignedTo }: Props) {
    const { claims } = useClaims();
    const tenantOptions = claims.tenants.includes("*")
        ? TenantSchema.options
        : TenantSchema.options.filter((tenant) => claims.tenants.includes(tenant));
    const [defaultTenant] = tenantOptions;

    // The form's defaults depend on the tiers, so it waits for them.
    const { data: membershipTiers } = useGet("membershipTiers", {});

    return (
        <Dialog open onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent
                size="medium"
                className="max-h-[calc(100dvh-2rem)] overflow-y-auto bg-white"
            >
                <DialogHeader>
                    <DialogTitle className="heading-4 text-zinc-900">
                        Create new member
                    </DialogTitle>
                </DialogHeader>

                {!defaultTenant ? (
                    <p className="text-sm text-zinc-500">
                        You don't have access to any tenant.
                    </p>
                ) : !membershipTiers ? (
                    <p className="text-sm text-zinc-500">Loading membership tiers…</p>
                ) : (
                    <NewMemberForm
                        defaultTenant={defaultTenant}
                        tenantOptions={tenantOptions}
                        membershipTiers={membershipTiers}
                        defaultAssignedTo={defaultAssignedTo}
                        onClose={onClose}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
